import { AxiosError } from 'axios'
import { FetchError } from 'ofetch'
import type { ZodIssue } from 'zod'
interface OriginalObject {
  [key: string]: string[]
}

interface ConvertedObject {
  [key: string]: { _errors: string[] }
}

const convertFirstLower = (string: string): string => {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

const convertToObject = (newKeyParts: string[], originalObject: OriginalObject, key: string) => {
  return newKeyParts.reduceRight(
    (acc: { _errors: string[] }, keyPart) => {
      return {
        [keyPart]: acc,
      }
    },
    { _errors: originalObject[key] },
  )
}

export const formatErrors = (originalObject: OriginalObject): ConvertedObject => {
  const converted: ConvertedObject = {}

  // temp patch for ApiException and AxiosError
  if (
    originalObject instanceof ApiException ||
    originalObject instanceof AxiosError ||
    originalObject.type === 'onResponseError' ||
    originalObject.type === 'onError'
  ) {
    originalObject = originalObject.result
  }

  Object.keys(originalObject).forEach((key: string) => {
    const newKey = convertFirstLower(key)

    const newKeyParts = newKey.split('.')
    if (newKeyParts.length > 1) {
      const newKeyObject = convertToObject(newKeyParts, originalObject, key)
      converted[newKeyParts[0]] = newKeyObject[newKeyParts[0]]
      return
    }

    converted[newKey] = {
      _errors: originalObject[key],
    }
  })

  return converted
}

export function formatTanstackError(error: Error) {
  const result = {}
  if (error instanceof FetchError) {
    for (const [key, value] of Object.entries(error.data)) {
      if (typeof value === 'string') {
        result[key] = [{ code: 'custom', message: value }]
      } else if (Array.isArray(value)) {
        const messages = value.filter((v): v is string => typeof v === 'string')
        if (messages.length > 0) {
          result[key] = messages.map((message) => ({
            code: 'custom',
            message,
          }))
        }
      }
    }
  }
  return result
}

export const generateTanstackErrorMap = (issues: ZodIssue[]) => {
  const errors = issues.reduce(
    (acc, issue) => {
      const path = issue.path
        .map((p) => (typeof p === 'number' ? `[${p}]` : `${p}`))
        .join('.')
        .replace(/\.\[/g, '[')
      acc[path] = acc[path] || []
      acc[path].push({ code: 'custom', message: issue.message })
      return acc
    },
    {} as Record<string, { code: string; message: string }[]>,
  )
  return errors
}
